import { checkWebpSupport } from "../../helpers/supports";

const addBodyClass = className => document.body.classList.add(className);

/**
 * Action types
 * @property {string} TARGET_DEVICE
 */
export const types = {
  FEATURE_SUPPORT: "FEATURE_SUPPORT",
  ROUTE_CHANGE: "ROUTE_CHANGE",
  TARGET_DEVICE: "TARGET_DEVICE",
};

/**
 * @namespace Reducers
 */
export const reducers = {
  /**
   * Updates feature support state
   * @param {string} state
   * @param {object} action
   * @param {string} action.type
   * @param {object} action.feature
   * @memberof Reducers
   */
  featureSupport: (state = {}, action) => {
    switch (action.type) {
      case types.FEATURE_SUPPORT:
        return { ...state, ...action.feature };
      default:
        return state;
    }
  },

  /**
   * Updates target device state
   * @param {string} state
   * @param {object} action
   * @param {string} action.type
   * @param {string} action.device
   * @memberof Reducers
   */
  targetDevice: (state = null, action) => {
    switch (action.type) {
      case types.TARGET_DEVICE:
        return action.device;
      default:
        return state;
    }
  },
};

/**
 * @namespace Actions
 */
export const actions = {
  /**
   * Check if browser supports certain features
   * @memberof Actions
   */
  checkFeatureSupport: () => (dispatch, getState) => {
    const { featureSupport } = getState();

    // Check if browser supports WebP images if result has not been persisted for the session
    if (!featureSupport.hasOwnProperty("webpLossy")) {
      checkWebpSupport("lossy").then(result => {
        addBodyClass(
          result ? "webp-lossy-supported" : "webp-lossy-not-supported"
        );
        dispatch(actions.updateFeatureSupport({ webpLossy: result }));
      });
    } else {
      addBodyClass(
        featureSupport.webpLossy
          ? "webp-lossy-supported"
          : "webp-lossy-not-supported"
      );
    }
  },

  /**
   * FIRE ROUTE CHANGE ACTION
   * - No associated state
   * - Used in other reducers
   * @memberof Actions
   */
  routeChange: () => ({
    type: types.ROUTE_CHANGE,
  }),

  /**
   * Update feature support
   * @param {object} feature
   * @memberof Actions
   */
  updateFeatureSupport: feature => ({
    type: types.FEATURE_SUPPORT,
    feature: feature,
  }),

  /**
   * Update target device
   * @param {string} device
   * @memberof Actions
   */
  updateTargetDevice: device => ({
    type: types.TARGET_DEVICE,
    device: device,
  }),
};
